import React from 'react';

import { observer } from 'mobx-react';
import { reverse } from 'named-urls';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';
import { ColumnActions } from 'components/Grid/types';
import routes from 'core/routes';
import { UserRole } from 'core/constants';
import { useStore } from 'utils/hooks/store';
import { TeamResponse } from 'utils/api/modules/teams/teams.types';
import api from 'utils/api';
import { ADMIN_AND_MANAGERS } from 'utils/roles/roleGroups';

interface Props {
  rowData: TeamResponse;
  actions: ColumnActions;
}

const TeamsActionCell: React.FC<Props> = ({ rowData, actions }) => {
  const { session, routing } = useStore();

  const userRole = session.user?.role as UserRole;

  const actionConfigs: ActionConfig[] = [
    {
      id: 'edit-button',
      label: 'Edit',
      onClick: () => {
        routing.push(reverse(routes.dashboard.settings.teams.details, { teamId: rowData.uuid }));
      },
    },
    {
      id: 'remove-button',
      label: 'Delete',
      visible: ADMIN_AND_MANAGERS.includes(userRole),
      onClick: async () => {
        await api.teams.deleteTeam(rowData.uuid)();
        await actions.refreshData();
      },
    },
  ];

  return <ActionCell actions={actionConfigs} recordName={rowData.name} />;
};

export default observer(TeamsActionCell);
